import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, computed, input, signal } from '@angular/core';
import { TableModule , TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ProjectService } from '../../../../../../shared/services/project.service';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { FireReviewerConfirmation } from '../../project-listing/modals/fire-reviewer/fire-reviewer.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BulkItemResult, BulkPositionAction, BulkPositionActionSummary, FireReviewerPayload } from '../../project.interface';
import { ToastService, serverErrorMessage } from '../../../../../../shared/services/toast.service';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { MultiSelectModule } from 'primeng/multiselect';
import { ReviewerDetailDialogService } from '../../../../../../shared/services/reviewer-detail-dialog.service';
import { TooltipModule } from 'primeng/tooltip';
import { RateFreelancersComponent } from '../../project-listing/modals/rate-freelancers/rate-freelancers.component';
import { FirmService } from '../../../../../../shared/services/firm.service';
import { UserClientVm } from '../../../../../../store/user/user.interface';
import { UserService } from '../../../../../../shared/services/user.service';
import { NotesService } from '../../../../../../shared/services/notes.service';
import { MessageComponentService } from '../../../message/message.component.service';
import { SendMailModalComponent } from '../modals/send-mail/send-mail.component';
import { constants } from '../../../../../../shared/constants/constants';
import { ViewReviewerDocumentsModalComponent } from '../modals/view-reviewer-documents-modal/view-reviewer-documents-modal.component';
import { OfferConfirmationModalComponent } from '../../create/offers/modals/offer-confirmation-modal/offer-confirmation-modal.component';
import { OfferService } from '../../../../../../shared/services/offers.service';
import { Offers } from '../../../../../../shared/interfaces/offers.interface';
import { FirebaseMessagingService } from '../../../../../../shared/services/firebase-messaging.service';
import moment from 'moment';
import { RoleService } from '../../../../../../shared/services/role.service';
import { CalendarModule } from 'primeng/calendar';
import { RateBulkFreelancersComponent } from '../../project-listing/modals/rate-bulk-freelancers/rate-bulk-freelancers.component';
import {PresumptiveApprovalModalComponent} from '../modals/presumptive-approval/presumptive-approval.component';
import { EmitterVisitorContext } from '@angular/compiler';
import { EmittersService } from '../../../../../../shared/services/emitters.service';
import { Observable, lastValueFrom } from 'rxjs';
import { DocumentService } from '../../../../../../shared/services/document-service';
import { HelperService } from '../../../../../../shared/services/helper.service';
import { ConfigurationService } from '../../../../../../shared/services/configuration.service';
import { PipesModule } from '../../../../../../shared/pipes/pipes.module';
import { StaffListTableComponent } from "./staff-list-table/staff-list-table.component";
import { BulkAction, BulkActionBarComponent, BulkSelectedPosition } from './bulk-action-bar/bulk-action-bar.component';
import { BulkResultsSummaryComponent, BulkResultRow } from '../modals/bulk-results-summary/bulk-results-summary.component';
import { BulkConfirmComponent, BulkConfirmData, BulkConfirmResult } from '../modals/bulk-confirm/bulk-confirm.component';
import { BulkMessageSummary } from '../../../message/message.interface';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OverlayPanelModule, OverlayPanel } from 'primeng/overlaypanel';
import { RatingModule } from 'primeng/rating';
import { BadgeModule } from 'primeng/badge';
import { InputNumberModule } from 'primeng/inputnumber';
import { TalentPoolService } from '../../../../../../shared/services/talent-pool.service';
import { TalentPool } from '../../../../../../shared/interfaces/talent-pool.interface';
import { ClientPortalService } from '../../../../../../shared/services/client-portal.service';
import { ConfirmationDialogService } from '../../../../../../shared/services/confirmation-dialog.service';

export interface StaffFilter {
  search: string;
  payRate: number | null;
  minRating: number | null;
  selectedRankings: string[];
  favoriteOnly: boolean;
  selectedTalentPoolIds: string[];
}

@Component({
  selector: 'app-staff-tab',
  standalone: true,
  imports: [
    TableModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    CommonModule,
    CheckboxModule,
    TabViewModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    ChipModule,
    InputTextModule,
    FloatLabelModule,
    MultiSelectModule,
    TooltipModule,
    CalendarModule,
    PipesModule,
    StaffListTableComponent,
    BulkActionBarComponent,
    InputTextareaModule,
    OverlayPanelModule,
    RatingModule,
    BadgeModule,
    InputNumberModule
],
  providers: [DialogService],
  host: {
    // MP-5691: reserves space for the fixed bulk action bar while it is open
    '[class.bulk-bar-open]': 'isBulkBarOpen()'
  },
  templateUrl: './staff-tab.component.html',
  styleUrl: './staff-tab.component.scss',
})
export class StaffTabComponent implements OnInit, OnChanges {

  @Input() projectId!: any;
  @Input() projectStaffList!: any;
  /**
   * MP-5752: true for a CLIENT (derived once by DetailsComponent from the session role).
   * Read-only staff list: no group buttons, no row or bulk actions, no documents, no
   * favorites or talent-pool filters; reviewer names are plain text. The data arrives
   * from the client-portal staff-list endpoint in the firm envelope.
   */
  readonly clientMode = input(false);
  @Input() projectBundle!: any;
  @Output() 
  updateAndReInitializeStaff: EventEmitter<void> = new EventEmitter();
  @Input()
  projectDetails! : any;
  expandedRows = {};
  checked: boolean = false;
  visible: boolean = false;
  emailType = constants.emailType;
  projectPositionsListed: number = 0;
  @Input() projectPositionsFilled: number = 0;
  ref: DynamicDialogRef | undefined;
  user!: UserClientVm;
  firmId!: string;
  rootFirmId: string = '';
  visibleDeleteModal = false;
  selectedDeleteRole: any;
  unReadDiscussions: Array<any> = [];
  isUnreadMessagesExist = false;
  restartDate = moment(new Date()).utc().toDate();
  restartTime = this.getDateTimeObjWithTime(9, 0) ;
  deleteRoleComment = '';
  roleStatus = constants.roleStatus;
  roleMinDate = moment(new Date()).utc().toDate();
  roleMaxDate = moment(new Date()).utc().add(constants.daysDiffrenceBetweenDate, 'days').toDate();
  isBackgroundCheckRequired!: boolean;
  secureBackgroundStatus = constants.secureBackgroundStatus;
  sortField: string = 'status'; // Default sort field
  sortOrder: number = 1; // 1 for ascending, -1 for descending
  customStatusOrder: string[] = [
    constants.positionStatusStaffTab.STAFFED,
    constants.positionStatusStaffTab.PENDING_APPROVAL,
    constants.positionStatusStaffTab.QUIT,
    constants.positionStatusStaffTab.DENIED,
    constants.positionStatusStaffTab.FIRED,
    constants.positionStatusStaffTab.COMPLETED,
  ];
  presumtpivelyQuit = 'PRESUMPTIVE_QUIT';
  isPwcEnabled = false;

  /**
   * MP-5690: bulk-selection state for the Staffed and Pending Approval sections,
   * keyed by position _id. Owned here (not in the child tables) so it survives
   * section collapse/expand; cleared on staff refetch and on role filter change.
   */
  readonly selectedPositionIds = signal<ReadonlySet<string>>(new Set<string>());
  /**
   * MP-5691: the selected positions resolved from selectedPositionIds, with their role status attached.
   * `projectStaffList` is a plain @Input, so it is not tracked here; that is fine because every
   * refetch clears the selection (ngOnChanges), which re-runs this computed against the new list.
   */
  readonly selectedPositions = computed<BulkSelectedPosition[]>(() => this.resolveSelectedPositions(this.selectedPositionIds()));
  readonly isBulkBarOpen = computed(() => this.selectedPositions().length > 0);

  // ── Staff-list filter state ──────────────────────────────────────────────────
  @ViewChild('staffFilterPanel') staffFilterPanel!: OverlayPanel;

  talentPools: TalentPool[] = [];
  /** Per-role filter settings, keyed by role._id */
  roleFilters = new Map<string, StaffFilter>();
  /** Cache key: `${poolId}:${roleId}` → Set of reviewer IDs that are in that pool for that role */
  poolReviewerIdsCache = new Map<string, Set<string>>();
  /** Role ID whose filter panel is currently open / being edited */
  currentRoleId = '';
  /** Working copy of filter being edited in the panel (not yet applied) */
  pendingFilter: StaffFilter = this.getDefaultFilter();
  rankingOptions = Object.values(constants.userRankings).map((r: string) => ({ label: r, value: r }));
  // ─────────────────────────────────────────────────────────────────────────────

  constructor(
    private projectService: ProjectService, 
    public dialogService: DialogService,
    private toastService: ToastService, 
    private reviewerDetailDialogService: ReviewerDetailDialogService,
    private firmService: FirmService,
    private userService: UserService,
    private notesService: NotesService,
    private messageCompoenentService: MessageComponentService,
    private offerService: OfferService,
    private firebaseMessagingService: FirebaseMessagingService,
    private roleService: RoleService,
    private emitterService: EmittersService,
    private documentService: DocumentService,
    public helperService: HelperService,
    private configurationService: ConfigurationService,
    private talentPoolService: TalentPoolService,
    private clientPortalService: ClientPortalService,
    private confirmationDialogService: ConfirmationDialogService
  ) { }

  ngOnInit(): void {
    this.user = this.userService.getSessionUser();
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    if (this.clientMode()) {
      // The CLIENT session user carries no firm block: rating and ranking key on the portal
      // session's firm, the background-check result is in the allowlisted DTO, and talent
      // pools are a firm-only endpoint (403, which the auth interceptor turns into a logout).
      this.firmId = this.clientPortalService.firmId();
      /**
       * MP-5636: the rating and ranking filters below match a reviewer's
       * tenant entry, which is keyed to the family ROOT - so `rootFirmId` has
       * to be set on THIS path too, or those filters silently match nothing
       * for a client-portal user. A portal firm is its own root (no portal
       * firm has a parent), so its own id is the right value.
       */
      this.rootFirmId = this.firmId;
      this.isBackgroundCheckRequired = true;
      this.initializeStaffList();
      return;
    }
    /**
     * MP-5643/MP-5636: kept SEPARATE, deliberately.
     *
     * `firmId` scopes WORK - it is forwarded to the staffing APIs and must be
     * the ACTING firm, which for a root-attached FM is the child they
     * selected in the switcher. `rootFirmId` is only for matching a
     * reviewer's tenant entry, which is keyed to the family root.
     * Identity up, work down.
     */
    this.firmId = this.userService.getUserFirmId();
    this.rootFirmId = this.userService.getFamilyRootFirmId();
    this.isBackgroundCheckRequired = this.user.firm?.isBackgroundCheckRequired;
    this.initializeStaffList();
    this.talentPoolService.getPoolsList().then(pools => (this.talentPools = pools)).catch(() => {});
  }

  ngOnChanges(changes: SimpleChanges): void {
    // The parent resets projectStaffList to {} while it refetches, then assigns the array.
    if (changes['projectStaffList'] && !changes['projectStaffList'].firstChange && Array.isArray(this.projectStaffList)) {
      // Staff list was refetched: rows are new objects, so any selection is stale.
      this.clearSelection();
      this.initializeStaffList();
    }
  }

  // ── MP-5690 selection ───────────────────────────────────────────────────────
  onSelectionChange(event: { positionIds: string[]; selected: boolean }): void {
    this.selectedPositionIds.update(current => {
      const next = new Set(current);
      event.positionIds.forEach(id => (event.selected ? next.add(id) : next.delete(id)));
      return next;
    });
  }

  clearSelection(): void {
    if (this.selectedPositionIds().size) {
      this.selectedPositionIds.set(new Set<string>());
    }
  }

  /** Walks every role's positionsList once and returns the selected positions with their role's status. */
  private resolveSelectedPositions(ids: ReadonlySet<string>): BulkSelectedPosition[] {
    const resolved: BulkSelectedPosition[] = [];
    // The parent sets projectStaffList to {} while refetching; never iterate a non-array.
    const roles: any[] = ids.size && Array.isArray(this.projectStaffList) ? this.projectStaffList : [];
    for (const role of roles) {
      for (const position of role.positionsList ?? []) {
        if (ids.has(position._id)) {
          resolved.push({ ...position, roleId: role._id, roleStatus: role.status });
        }
      }
    }
    return resolved;
  }

  /** MP-5694: routes the action bar to the bulk flows. Message → MP-5692 endpoint; fire/approve/deny → MP-5693 endpoints. */
  onBulkAction(action: BulkAction): void {
    if (action === 'message') {
      this.openBulkMessage();
    } else {
      this.openBulkPositionAction(action);
    }
  }

  /** Returns the selected positions, or null (with a toast) when the batch is empty or over the backend cap. */
  private takeBulkBatch(verb: string): BulkSelectedPosition[] | null {
    const positions = this.selectedPositions();
    if (!positions.length) {
      return null;
    }
    if (positions.length > constants.bulkActions.maxBatchSize) {
      this.toastService.showError(`You can ${verb} up to ${constants.bulkActions.maxBatchSize} candidates at a time`);
      return null;
    }
    return positions;
  }

  private candidateName(p: BulkSelectedPosition): string {
    return `${p.reviewer.firstName} ${p.reviewer.lastName}`;
  }

  openBulkMessage(): void {
    const positions = this.takeBulkBatch('message');
    if (!positions) {
      return;
    }
    this.messageCompoenentService.openBulkMessageDialog({
      projectId: this.projectId,
      positionIds: positions.map(p => p._id),
      recipientNames: positions.map(p => this.candidateName(p))
    }).subscribe((summary: BulkMessageSummary | undefined) => {
      if (summary && Array.isArray(summary.results)) {
        this.reportBulkResults('Message sent', 'Message sent to', this.toResultRows(summary.results, positions));
        // Messaging does not change any position, so no staff refetch is needed here.
        this.clearSelection();
      }
    });
  }

  /** Copy per action; approve reads "Confirm" under PWC (MP-5694 item 3). */
  private bulkActionCopy(action: BulkPositionAction): { verb: string; confirm: BulkConfirmData; headline: string; toastVerb: string } {
    const approveWord = this.isPwcEnabled ? 'Confirm' : 'Approve';
    const approved = this.isPwcEnabled ? 'Confirmed' : 'Approved';
    const n = (count: number) => `${count} candidate${count === 1 ? '' : 's'}`;
    /** "1 candidate's" / "3 candidates'" */
    const possessive = (count: number) => `${n(count)}${count === 1 ? '\'s' : '\''}`;
    const count = this.selectedPositions().length;
    switch (action) {
      case 'fire':
        return {
          verb: 'fire', headline: 'Fired', toastVerb: 'Fired',
          confirm: {
            heading: `Are you sure you want to fire ${n(count)}?`,
            names: [], confirmLabel: 'Fire', confirmSeverity: 'danger',
            reasonLabel: 'Message',
            reasonPlaceholder: 'Message to be shared with staff on notification of position completion. (optional)'
          }
        };
      case 'deny':
        return {
          verb: 'deny', headline: 'Denied', toastVerb: 'Denied',
          confirm: {
            heading: `Deny ${possessive(count)} pending position${count === 1 ? '' : 's'}?`,
            names: [], confirmLabel: 'Deny', confirmSeverity: 'danger', reasonLabel: 'Reason'
          }
        };
      case 'approve':
      default:
        return {
          verb: approveWord.toLowerCase(), headline: approved, toastVerb: approved,
          confirm: {
            heading: `${approveWord} ${possessive(count)} pending position${count === 1 ? '' : 's'}?`,
            names: [], confirmLabel: approveWord, confirmSeverity: 'success', reasonLabel: 'Reason'
          }
        };
    }
  }

  /**
   * MP-5694 items 1, 3, 4, 5, 6: confirm (listing names) → one bulk call → results summary →
   * one staff refetch → clear selection → for fire, hand the fired candidates to the rating modal.
   */
  openBulkPositionAction(action: BulkPositionAction): void {
    const copy = this.bulkActionCopy(action);
    const positions = this.takeBulkBatch(copy.verb);
    if (!positions) {
      return;
    }
    copy.confirm.names = positions.map(p => this.candidateName(p));

    this.ref = this.dialogService.open(BulkConfirmComponent, {
      header: 'Confirmation',
      width: '40vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      data: copy.confirm
    });

    this.ref.onClose.subscribe((result: BulkConfirmResult | undefined) => {
      if (!result) {
        return; // cancelled: keep the selection
      }
      this.projectService.bulkPositionAction(action, {
        projectId: this.projectId,
        items: positions.map(p => ({ reviewerId: p.reviewer._id, positionId: p._id })),
        message: result.reason,
        isDRSSubmitted: false
      }).subscribe({
        next: (summary: BulkPositionActionSummary) => {
          const results = Array.isArray(summary?.results) ? summary.results : [];
          this.reportBulkResults(copy.headline, copy.toastVerb, this.toResultRows(results, positions));
          // Clear before the refetch: the parent replaces the list synchronously and the selection
          // must not be re-resolved against the placeholder it uses while loading.
          this.clearSelection();
          this.updateAndReInitializeStaff.emit(); // exactly one refetch per batch
          if (action === 'fire') {
            const firedIds = new Set(results.filter(r => r.success).map(r => r.positionId));
            const fired = positions.filter(p => firedIds.has(p._id));
            if (fired.length) {
              this.openRatingForFiredCandidates(fired);
            }
          }
        },
        error: (err: unknown) => {
          // Whole-call failures happen before the backend touches any position (validation,
          // authorization), so the selection is kept for a retry. A 4xx message is shown verbatim.
          this.toastService.showError(serverErrorMessage(err, `Error while trying to ${copy.verb} staff members. Please try again`));
        }
      });
    });
  }

  /**
   * MP-5694 item 6: after a successful bulk fire, open RateBulkFreelancersComponent for the fired
   * candidates only. Fired positions may span roles, so the modal receives one entry per role.
   */
  private async openRatingForFiredCandidates(fired: BulkSelectedPosition[]): Promise<void> {
    const byRole = new Map<string, BulkSelectedPosition[]>();
    fired.forEach(p => byRole.set(p.roleId, [...(byRole.get(p.roleId) ?? []), p]));

    const roleReviewers: any[] = [];
    try {
      for (const [roleId, positions] of byRole) {
        const role = await this.roleService.getProjectRoleReviewers(this.projectId || '', roleId, true);
        if (!role?.reviewers?.length) {
          continue;
        }
        const positionIds = new Set(positions.map(p => p._id));
        const reviewerIds = new Set(positions.map(p => p.reviewer._id));
        const reviewers = role.reviewers.filter((r: any) => positionIds.has(r.position) || (!r.position && reviewerIds.has(r._id)));
        if (reviewers.length) {
          roleReviewers.push({ ...role, reviewers });
        }
      }
    } catch (error) {
      this.toastService.showError('Fired successfully, but the rating form could not be opened. You can rate them from Previously Staffed.');
      return;
    }
    if (roleReviewers.length) {
      this.openBulkRatingReviewerModal(roleReviewers);
    }
  }

  /** Maps backend per-item results onto display rows, falling back to the selected row's name. */
  private toResultRows(results: BulkItemResult[], positions: BulkSelectedPosition[]): BulkResultRow[] {
    const nameById = new Map(positions.map(p => [p._id, this.candidateName(p)]));
    return results.map(r => ({
      name: r.reviewerName || nameById.get(r.positionId) || r.positionId,
      success: r.success,
      error: r.error
    }));
  }

  /** All succeeded → toast. Any failure → summary dialog listing the failures and reasons (MP-5694 item 4). */
  private reportBulkResults(headline: string, toastVerb: string, rows: BulkResultRow[]): void {
    const failed = rows.filter(r => !r.success).length;
    if (!failed) {
      this.toastService.showSuccess(`${toastVerb} ${rows.length} candidate${rows.length === 1 ? '' : 's'}`);
      return;
    }
    this.dialogService.open(BulkResultsSummaryComponent, {
      header: 'Bulk action results',
      width: '40vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      data: { headline, results: rows }
    });
  }
  // ───────────────────────────────────────────────────────────────────────────

  private initializeStaffList(): void {
    if (!Array.isArray(this.projectStaffList)) {
      return;
    }
    this.projectStaffList.map((role: any) => {
      role.positionsList.map((position: any) => {
        position.staffedAt = this.getDateValue(position, role.status);
        position.staffedLabel = this.getPositionDateInfo(position, role.status).label;
      });
      this.computePositionSections(role);
    });
  }

  computePositionSections(role: any): void {
    const id = role._id;
    role._activePositions = this.applyFiltersToPositions(this.getActivePositions(role.positionsList), id);
    role._pendingApprovalPositions = this.applyFiltersToPositions(this.getPendingApprovalPositions(role.positionsList), id);
    role._deniedPositions = this.applyFiltersToPositions(this.getDeniedPositions(role.positionsList), id);
    role._previouslyAssignedPositions = this.applyFiltersToPositions(this.getPreviouslyAssignedPositions(role.positionsList), id);
    // Totals for "Showing X of Y"
    role._totalPositionsCount = role.positionsList?.length ?? 0;
    role._filteredPositionsCount = [
      ...role._activePositions,
      ...role._pendingApprovalPositions,
      ...role._deniedPositions,
      ...role._previouslyAssignedPositions
    ].length;
  }

  documentKey(reviewer: any): Array<string>{
    return Object.keys(reviewer.docs.blank);
  }

  getMessageNoOfDocumentUploadedByUser(reviewer: any): string{
    return `${Object.keys(reviewer?.docs?.filled[reviewer._id] || {}).length} of ${Object.keys(reviewer?.docs?.blank || {}).length} documents completed`
  }

  isUserCompletedOrPartiallyCompletedTheDocuments(reviewer: any): string{
    const documents = Object.keys(reviewer?.docs?.blank || {});
    const uploadedDocuments = Object.keys(reviewer?.docs?.filled[reviewer._id] || {});

    if(!uploadedDocuments.length){
      return constants.documentUploadStatus.NOT_UPLOADED;
    }

    if(documents.length > uploadedDocuments.length){
      return constants.documentUploadStatus.PARTIALLY_UPLOADED;
    }

    return constants.documentUploadStatus.UPLOADED;
  }

  showFireReviewerDialog($event:Event, reviewerId: string, positionId: string, role: any, firstName: string, lastName: string) {
    $event.stopPropagation();
    this.ref = this.dialogService.open(FireReviewerConfirmation, {
      data: {
        fullName: `${firstName} ${lastName}`
      },
      header: 'Confirmation',
      width: '30vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });

    this.ref.onClose.subscribe((data: FireReviewerPayload) => {
      if (data) {
        this.projectService.fireReviewerFromProject(reviewerId, positionId, data.endMessage, data.isDRSSubmittedChecked).subscribe({
          next: (response) => {
            response.isDRSSubmitted = !!data.isDRSSubmittedChecked;
            this.toastService.showSuccess('Fired successfully');
            this.updateAndReInitializeStaff.emit();
            this.openRatingReviewerModal({
              reviewerId, 
              positionId,
              projectId: this.projectId,
              roleId: role,
              firstName,
              lastName,
              projectDetails: this.projectDetails
            });
          },
          error: (error) => {
            this.toastService.showError('Error while firing staff member. Please try again');
          }
        });
      }
    });
  }

  openReviewerDocumentDetail(reviewer: any): void{
    this.dialogService.open(ViewReviewerDocumentsModalComponent, {
      header: `${reviewer.firstName} ${reviewer.lastName} Documents`,
      width: '70vw',
      contentStyle: { overflow: 'auto', 'max-height': '75vh' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      data: {...reviewer}
    });
  }

  async openRatingReviewerModal(data: any): Promise<void>{
    const firmFavorites = await this.firmService.getFirmFavourites(this.firmId || '');
    const rateReviewerModalRef = this.dialogService.open(RateFreelancersComponent, {
      header: `Rate ${data.firstName} ${data.lastName}`,
      width: '50vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      data: {
        ...data,
        firmFavorites: firmFavorites && firmFavorites.favorites.length ? firmFavorites.favorites : [],
        firmId: this.firmId
      }
    });

    rateReviewerModalRef.onClose.subscribe(async (modalResponse) => {
      if(modalResponse && modalResponse.isConfirm){
        const ratingInfo = {...modalResponse.ratingInfo};
        const roleReviewersRating: any = {
          rate: []
        };

        const rate = {
          position: ratingInfo.positionId,
          stars: ratingInfo.rating,
          role: ratingInfo.roleId,
          isRestricted: ratingInfo.isRestricted,
          workTogether: ratingInfo.workTogether
        }

        roleReviewersRating.rate.push(rate);

        try{
          await this.projectService.submitReviewerRating(this.projectId, roleReviewersRating);
          if(ratingInfo.notes){
            await this.notesService.addNotes(data.reviewerId, ratingInfo.notes);
          }
          this.toastService.showSuccess('Reviewer ratings submitted successfully');
          this.updateAndReInitializeStaff.emit();
        }catch(error){
          this.toastService.showError(`Error occurred while submitting rating for staff member ${data.firstName} ${data.lastName}. Please try again.`)
        }

      }
    })
  }

  async openBulkRatingReviewerModal(data: any): Promise<void>{
    const rateReviewerModalRef = this.dialogService.open(RateBulkFreelancersComponent, {
      header: 'Rate Freelancers',
      width: '50vw',
      height: '60vh',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      data: {
        projectId: this.projectId,
        endRole: true,
        reviewers: data,
        codeName: this.projectDetails.codeName,
        firmId: this.firmId
      }
    });

    rateReviewerModalRef.onClose.subscribe(async (modalResponse) => {
      if(modalResponse && modalResponse.isConfirm){
        try{
          await this.projectService.submitReviewerRating(this.projectId || '', modalResponse.roleReviewersRating);
          if(modalResponse.notes && modalResponse.notes.length){
            await this.notesService.bulkAdd(modalResponse.notes);
          }
          this.toastService.showSuccess('Reviewer ratings submitted successfully');
          this.hideDeleteModal(true);
        } catch(error: any){
          this.toastService.showError(error && error.message ? error.message : 'Some error has occurred')
        }
      }
    });
  }

  onRowExpand(event: TableRowExpandEvent) { 
    const role = event.data;
    this.computePositionSections(role);
    const initialSort = { field: 'status', order: -1 };
    if (role._activePositions?.length) this.sortPositionsList(initialSort, role, 'staffed');
    if (role._pendingApprovalPositions?.length) this.sortPositionsList(initialSort, role, 'pendingApproval');
    if (role._deniedPositions?.length) this.sortPositionsList(initialSort, role, 'denied');
    if (role._previouslyAssignedPositions?.length) this.sortPositionsList(initialSort, role, 'previouslyAssigned');
  }

  onRowCollapse(event: TableRowCollapseEvent) { }

  async showMailDialog(projectId: string, emailType: string, firm: any, recipient: string, roleId: string, reviewerId: string) {
    const projectOwners = await this.firmService.getFirmProjectOwners(firm._id);
    this.dialogService.open(SendMailModalComponent, {
      header: 'Send email',
      width: '50vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      data: {
        projectId,
        emailType,
        firm,
        recipient,
        roleId,
        reviewerId,
        projectOwners: projectOwners.users
      }
    });
  }

  openReviewerDialog(id:string){
    this.reviewerDetailDialogService.openDialog(id);
  }

  openCreateChatReviewer(position:any, presumptive = false){

    let node = {
      projectId:position.project,
      roleId:position.role,
      reviewerId:position.reviewer._id,
      msgType: 'REVIEWER',
      reviewer: position.reviewer,
      status: position.status,
      from: 'staff-tab',
      presumptive
    }
    this.messageCompoenentService.openCreateDiscussion(node);
  }


  openCreateChat(role:any){

    let node = {
      projectId: role.positionsList[0].project,
      roleId: role._id,
      reviewerId: null,
      msgType: "ROLE",
      title: role.roleType,
      status: role.status,
      node: role
    };

    this.messageCompoenentService.openNewMessageDialog(node);

  }

  openCreateChatRolePresumptiveGroup(role:any){

    let node = {
      projectId: role.positionsList[0].project,
      roleId: role._id,
      reviewerId: null,
      msgType: "ROLE",
      title: role.roleType,
      status: "pending",
      node: role
    };

    this.messageCompoenentService.openNewMessageDialog(node);
    
  }

  openGroupChat(){

    let node = {
      projectId: this.projectDetails.id,
      roleId: null,
      reviewerId: null,
      msgType: "PROJECT",
      title: this.projectDetails.codeName,
      status: this.projectDetails.status,
      node: this.projectDetails
    };
    this.messageCompoenentService.openNewMessageDialog(node);
  }

  async openImmediateSendOfferModal(role: any, reviewer: any): Promise<void> {
    const selectedRole = await lastValueFrom(this.roleService.getProjectRole(this.projectId, role));
    reviewer = {
      ...reviewer,
      roleId : role,
      projectId: this.projectId,
      isStarted: selectedRole.isStarted? selectedRole.isStarted: selectedRole.status === constants.roleStatus.started? true : false
    }
    this.ref = this.dialogService.open(
      OfferConfirmationModalComponent,
      this.getOfferModalConfig('Do you want to send an offer to this candidate?', reviewer)
    );

    this.ref.onClose.subscribe(async (offer: Offers) => {
      if (offer) {
        const payload = {
          ...offer,
          positionStarted: offer.positionStarted,
          reviewerId: reviewer._id,
          roleId: role,
        };
        await this.offerService.createOffer(payload);
        this.toastService.showSuccess('Offer sent successfully');
      }
    })
  }
  

  getOfferModalConfig(modalType: string, data?: any) {
    return {
      header: modalType,
      width: data?.isStarted? '50vw' : '25vw',
      baseZIndex: 10000,
      contentStyle: { overflow: 'visible' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      data: {
        ...data,
      },
    };
  }

  getUnreadMessageCount(){
    this.firebaseMessagingService.getFirmUnReadMessages().subscribe((unReadDiscussions:any)=>{
      this.unReadDiscussions = unReadDiscussions;
    });
  }

  async openDeleteModal(data:any){
    this.roleService.getProjectRole(this.projectDetails._id, data._id).subscribe({
      next: (response) => {
        this.visibleDeleteModal = true;
        this.selectedDeleteRole = response;
        this.isUnreadMessagesExist = !!(this.unReadDiscussions.find(discussion => {
          return discussion.roleId === this.selectedDeleteRole._id && discussion.pmUnReadMessageCount > 0;
        }));
        this.restartDate = moment(new Date()).utc().toDate();
      }
    });
  }
  hideDeleteModal(getRoleApi?:boolean){
    if(getRoleApi){
      this.updateAndReInitializeStaff.emit();
    }
    this.deleteRoleComment = '';
    this.visibleDeleteModal = false;
  }

  // ── Filter helpers ──────────────────────────────────────────────────────────

  getDefaultFilter(): StaffFilter {
    return {
      search: '',
      payRate: null,
      minRating: null,
      selectedRankings: [],
      favoriteOnly: false,
      selectedTalentPoolIds: [],
    };
  }

  getRoleFilter(roleId: string): StaffFilter {
    return this.roleFilters.get(roleId) ?? this.getDefaultFilter();
  }

  isFilterActive(roleId: string): boolean {
    const f = this.getRoleFilter(roleId);
    return !!(
      f.search ||
      f.payRate != null ||
      f.minRating != null ||
      f.selectedRankings.length ||
      f.favoriteOnly ||
      f.selectedTalentPoolIds.length
    );
  }

  getActiveFilterCount(roleId: string): number {
    const f = this.getRoleFilter(roleId);
    let count = 0;
    if (f.search) count++;
    if (f.payRate != null) count++;
    if (f.minRating != null) count++;
    if (f.selectedRankings.length) count++;
    if (f.favoriteOnly) count++;
    if (f.selectedTalentPoolIds.length) count++;
    return count;
  }

  applyFiltersToPositions(positions: any[], roleId: string): any[] {
    const f = this.getRoleFilter(roleId);
    const isActive = this.isFilterActiveForFilter(f);
    if (!isActive) return positions;
    // Build a per-pool allowed set from cache so positionMatchesFilter stays synchronous
    const poolAllowedSets = new Map<string, Set<string>>();
    for (const poolId of f.selectedTalentPoolIds) {
      const key = `${poolId}:${roleId}`;
      poolAllowedSets.set(poolId, this.poolReviewerIdsCache.get(key) ?? new Set());
    }
    return positions.filter(p => this.positionMatchesFilter(p, f, poolAllowedSets));
  }

  private isFilterActiveForFilter(f: StaffFilter): boolean {
    return !!(
      f.search ||
      f.payRate != null ||
      f.minRating != null ||
      f.selectedRankings.length ||
      f.favoriteOnly ||
      f.selectedTalentPoolIds.length
    );
  }

  positionMatchesFilter(position: any, f: StaffFilter, poolAllowedSets?: Map<string, Set<string>>): boolean {
    const reviewer = position.reviewer;
    if (!reviewer) return true;

    if (f.search) {
      const fullName = `${reviewer.firstName ?? ''} ${reviewer.lastName ?? ''}`.toLowerCase();
      if (!fullName.includes(f.search.toLowerCase())) return false;
    }

    if (f.payRate != null && (position.hourlyRate ?? 0) !== f.payRate) return false;

    if (f.minRating != null) {
      const tenant = reviewer.tenants?.find((t: any) => t.firm === this.rootFirmId);
      const rating = tenant?.defaultRatings ?? 0;
      if (rating < f.minRating) return false;
    }

    if (f.selectedRankings.length) {
      const tenant = reviewer.tenants?.find((t: any) => t.firm === this.rootFirmId);
      const ranking = tenant?.ranking ?? '';
      if (!f.selectedRankings.includes(ranking)) return false;
    }

    if (f.favoriteOnly && !reviewer.favorite) return false;

    if (f.selectedTalentPoolIds.length && poolAllowedSets) {
      const reviewerId = reviewer._id?.toString();
      const inAnyPool = f.selectedTalentPoolIds.some(poolId => poolAllowedSets.get(poolId)?.has(reviewerId));
      if (!inAnyPool) return false;
    }

    return true;
  }

  openStaffFilterPanel(role: any, event: Event): void {
    this.currentRoleId = role._id;
    const stored = this.getRoleFilter(role._id);
    this.pendingFilter = {
      ...stored,
      selectedRankings: [...stored.selectedRankings],
      selectedTalentPoolIds: [...stored.selectedTalentPoolIds],
    };
    this.staffFilterPanel.toggle(event);
  }

  async applyStaffFilter(): Promise<void> {
    const roleId = this.currentRoleId;
    const role = this.projectStaffList.find((r: any) => r._id === roleId);

    // Collect ALL reviewer IDs currently in this role's staff list
    const allReviewerIds: string[] = (role?.positionsList ?? [])
      .map((p: any) => p.reviewer?._id?.toString())
      .filter(Boolean);

    // For each selected pool, ask backend which of these reviewers are in that pool
    for (const poolId of this.pendingFilter.selectedTalentPoolIds) {
      const cacheKey = `${poolId}:${roleId}`;
      if (!this.poolReviewerIdsCache.has(cacheKey)) {
        await this._loadPoolCacheForRole(poolId, roleId, allReviewerIds);
      }
    }

    this.roleFilters.set(roleId, {
      ...this.pendingFilter,
      selectedRankings: [...this.pendingFilter.selectedRankings],
      selectedTalentPoolIds: [...this.pendingFilter.selectedTalentPoolIds],
    });

    this._recomputeRole(roleId);
    this.staffFilterPanel.hide();
  }

  clearStaffFilter(roleId: string): void {
    this.roleFilters.delete(roleId);
    // Evict role-scoped pool cache entries so re-applying fetches fresh data
    for (const key of Array.from(this.poolReviewerIdsCache.keys())) {
      if (key.endsWith(`:${roleId}`)) this.poolReviewerIdsCache.delete(key);
    }
    this._recomputeRole(roleId);
  }

  private async loadPoolReviewerIds(poolId: string): Promise<void> {
    // kept for API compatibility; delegates to role-scoped version with no role context
    try {
      const ids = await this.talentPoolService.checkReviewersInPool(poolId, []);
      this.poolReviewerIdsCache.set(poolId, new Set(ids));
    } catch {
      this.poolReviewerIdsCache.set(poolId, new Set());
    }
  }

  private async _loadPoolCacheForRole(poolId: string, roleId: string, reviewerIds: string[]): Promise<void> {
    const cacheKey = `${poolId}:${roleId}`;
    try {
      const matchingIds = await this.talentPoolService.checkReviewersInPool(poolId, reviewerIds);
      this.poolReviewerIdsCache.set(cacheKey, new Set(matchingIds));
    } catch {
      this.poolReviewerIdsCache.set(cacheKey, new Set());
    }
  }

  getTalentPoolName(poolId: string): string {
    return this.talentPools.find(p => p._id === poolId)?.name ?? poolId;
  }

  removeSearchChip(roleId: string): void {
    const f = this.getRoleFilter(roleId);
    f.search = '';
    this.roleFilters.set(roleId, f);
    this._recomputeRole(roleId);
  }

  removePayRateChip(roleId: string): void {
    const f = this.getRoleFilter(roleId);
    f.payRate = null;
    this.roleFilters.set(roleId, f);
    this._recomputeRole(roleId);
  }

  removeRatingChip(roleId: string): void {
    const f = this.getRoleFilter(roleId);
    f.minRating = null;
    this.roleFilters.set(roleId, f);
    this._recomputeRole(roleId);
  }

  removeRankingChip(roleId: string, rank: string): void {
    const f = this.getRoleFilter(roleId);
    f.selectedRankings = f.selectedRankings.filter(r => r !== rank);
    this.roleFilters.set(roleId, f);
    this._recomputeRole(roleId);
  }

  removeFavoriteChip(roleId: string): void {
    const f = this.getRoleFilter(roleId);
    f.favoriteOnly = false;
    this.roleFilters.set(roleId, f);
    this._recomputeRole(roleId);
  }

  removeTalentPoolChip(roleId: string, poolId: string): void {
    const f = this.getRoleFilter(roleId);
    f.selectedTalentPoolIds = f.selectedTalentPoolIds.filter(id => id !== poolId);
    this.roleFilters.set(roleId, f);
    this._recomputeRole(roleId);
  }

  private _recomputeRole(roleId: string): void {
    // Filters changed for this role: the visible set changed, so drop the selection (MP-5690).
    this.clearSelection();
    const role = this.projectStaffList.find((r: any) => r._id === roleId);
    if (role) {
      this.computePositionSections(role);
      const initialSort = { field: 'status', order: -1 };
      if (role._activePositions?.length) this.sortPositionsList(initialSort, role, 'staffed');
      if (role._pendingApprovalPositions?.length) this.sortPositionsList(initialSort, role, 'pendingApproval');
      if (role._deniedPositions?.length) this.sortPositionsList(initialSort, role, 'denied');
      if (role._previouslyAssignedPositions?.length) this.sortPositionsList(initialSort, role, 'previouslyAssigned');
    }
  }

  // ── End filter helpers ──────────────────────────────────────────────────────

  deleteRole(){
    if(this.projectDetails.id){
      if(this.selectedDeleteRole && this.selectedDeleteRole.status === constants.roleStatus.active){
        this.projectService.deleteProjectRole(this.projectId, this.selectedDeleteRole._id, this.deleteRoleComment).subscribe(async (resp:any)=>{
          this.toastService.showSuccess('Role Deleted Successfully');
          if(this.selectedDeleteRole.isStarted && this.selectedDeleteRole.occupiedPositions){
            const roleReviewers = await this.roleService.getProjectRoleReviewers(this.projectId || '', this.selectedDeleteRole._id, true);
            if(roleReviewers && roleReviewers.reviewers.length){
              this.openBulkRatingReviewerModal(roleReviewers);
            }
          }
          this.hideDeleteModal(true);
        })
      }
    }
  }

  presumptiveApproveDeny($event: Event, position: any, roleName: string) {
    let heading = `Please approve or deny ${position.reviewer.firstName} ${position.reviewer.lastName}'s position on role "${roleName}"?`;
    let header = 'Approve or deny candidate’s position';
    if(this.isPwcEnabled){
      heading = `Confirm or deny ${position.reviewer.firstName} ${position.reviewer.lastName}'s position on role "${roleName}"?`;
      header = 'Confirm presumptive position';
    }
    const data = {
      heading,
      from: 'staffTab',
      textAreaHeading: 'Reason'
    }
    $event.stopPropagation();
      this.ref = this.dialogService.open(PresumptiveApprovalModalComponent, {
          data: data,
          header,
          width: '40vw',
          contentStyle: { overflow: 'auto' },
          breakpoints: {
              '960px': '75vw',
              '640px': '90vw'
          }
      });
      this.ref.onClose.subscribe((data: any) => {
          if (data.approve) {
            this.projectService.approveReviewerFromPosition(position.reviewer._id, position._id, data.reason).then(()=>{
              this.toastService.showSuccess("Position successfully approved.");
              this.emitterService.staffTabEmitter.emit();
            })
          }
          if(data.deny){
            this.projectService.denyReviewerFromPosition(position.reviewer._id, position._id, data.reason).then(()=>{
              this.toastService.showSuccess("Position successfully denied.");
              this.emitterService.staffTabEmitter.emit();
            })
          }  
      });
  }

  /**
   * MP-5755: the client's soft approve, modeled on the presumptive Approve gesture.
   * Confirm, then POST (select) or DELETE (withdraw) the MP-5753 selection record;
   * nothing about the position changes, so the row is updated in place rather than
   * refetching the whole list (which would collapse the expanded roles). A reload
   * shows the same state from the portal DTO's `clientSelected`.
   */
  clientSelectPosition($event: Event, position: any, roleType: string): void {
    $event.stopPropagation();
    const name = `${position.reviewer.firstName} ${position.reviewer.lastName}`;
    const withdrawing = !!position.clientSelected;
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      header: withdrawing ? 'Withdraw selection' : 'Select for this project',
      message: withdrawing
        ? `Withdraw your selection of ${name} for role "${roleType}"?`
        : `Select ${name} for role "${roleType}" on this project? The firm will see your selection; it does not change the position.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: withdrawing ? 'Withdraw' : 'Select',
      rejectLabel: 'Cancel',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        const request: Observable<unknown> = withdrawing
          ? this.clientPortalService.withdrawSelection(this.projectId, position._id)
          : this.clientPortalService.selectPosition(this.projectId, position._id);
        request.subscribe({
          next: () => {
            position.clientSelected = !withdrawing;
            this.toastService.showSuccess(withdrawing ? 'Selection withdrawn' : `${name} selected for this project`);
          },
          error: (err: unknown) => this.toastService.showError(serverErrorMessage(err, `Error while trying to ${withdrawing ? 'withdraw the selection' : 'select the reviewer'}. Please try again`))
        });

      }
    });
  }

  downloadDocuments(){

    if(this.projectBundle){
      window.open(this.documentService.getDocumentPathById(this.projectBundle._id) || '', '_blank');
    }
  }

  getDateTimeObjWithTime(hours: number, mins: number) {
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(mins);
    return date;
  }

  isMinor(_dob: string): boolean {
    const dob = new Date(_dob);
    return new Date().getTime() < new Date(dob.setFullYear(dob.getFullYear() + 18)).getTime();
  }

  getDateValue(item: any, roleStatus: string) {
      // First try filledAt
      return new Date(this.getPositionDateInfo(item,roleStatus).date).getTime();
  };
        
  // Sorting for expanded positionsList
  sortPositionsList(event: { field: string; order: number }, projectStaffList: any, section: string) {

    let positionList: any[];
    const status = projectStaffList.status;

    if (section === 'pendingApproval') {
      positionList = projectStaffList._pendingApprovalPositions;
    } else if (section === 'denied') {
      positionList = projectStaffList._deniedPositions;
    } else if (section === 'previouslyAssigned') {
      positionList = projectStaffList._previouslyAssignedPositions;
    } else {
      positionList = projectStaffList._activePositions;
    }

    const field = event.field;
    let order = event.order;

    if (field === 'status') {
      order = -1; // Default to descending order for status for staffed date
      // Custom status order, always ascending
      positionList.sort((a: any, b: any) => {
        // Get the effective status (considering presumptive status)
        const getEffectiveStatus = (item: any) => {
          // Check for "Pending Approval" status first - handles both conditions from the template
          if (
            item.isPresumptivelyPending || 
            (item.presumptive && item.presumptive.status === 'ASSIGNED' && item.status === 'OCCUPIED')
          ) {
            return constants.positionStatusStaffTab.PENDING_APPROVAL;
          }
          
          // If it has presumptive.status === 'DENIED' and status === 'FIRED', treat as DENIED
          if (item.presumptive && item.presumptive.status === 'DENIED' && item.status === 'FIRED') {
            return constants.positionStatusStaffTab.DENIED;
          }
          
          // Map 'OCCUPIED' to 'STAFFED' for sorting purposes
          if (item.status === 'OCCUPIED') {
            return constants.positionStatusStaffTab.STAFFED;
          }
          
          // Otherwise use the regular status
          return item.status;
        };

        const statusA = this.customStatusOrder.indexOf(getEffectiveStatus(a));
        const statusB = this.customStatusOrder.indexOf(getEffectiveStatus(b));

        // If statuses are different, sort by status
        if (statusA !== statusB) {
          return statusA - statusB;
        }
        
        // If statuses are the same, sort by date using the selected order
        
        return order * (this.getDateValue(a,status) - this.getDateValue(b,status));
      });

    } else if (field === 'staffedAt') {
      // Date sorting
      positionList.sort((a: any, b: any) => {
        return order * (this.getDateValue(a,status) - this.getDateValue(b,status));
      });

    } else if (field === 'candidateName') {
      // Name sorting
      positionList.sort((a: any, b: any) => {
        const nameA = `${a.reviewer.firstName} ${a.reviewer.lastName}`.toLowerCase();
        const nameB = `${b.reviewer.firstName} ${b.reviewer.lastName}`.toLowerCase();
        return order * nameA.localeCompare(nameB);
      });
    } else if(field === 'ranking'){
      // Ranking sorting
      positionList.sort((a: any, b: any) => {
        const rankA = a.reviewer.tenants?.[0]?.ranking || 0;
        const rankB = b.reviewer.tenants?.[0]?.ranking || 0;
        return order * rankA.toLocaleString().localeCompare(rankB.toLocaleString());
      });
    } else if(field === 'rating'){
      // Rating sorting
      positionList.sort((a: any, b: any) => {
        const ratingA = a.reviewer.tenants?.[0]?.defaultRatings || 0;
        const ratingB = b.reviewer.tenants?.[0]?.defaultRatings || 0;
        return order * (ratingA - ratingB);
      });

    } else if(field === 'hourlyRate'){
      // Hourly rate sorting
      positionList.sort((a: any, b: any) => {
        const rateA = a.hourlyRate || 0;
        const rateB = b.hourlyRate || 0;
        return order * (rateA - rateB);
      });
    }
    return positionList;
  }

  /**
   * Returns the appropriate date and label for a position based on its status
   * @param position The position object
   * @param projectStaffListStatus The status of the parent project staff list
   * @returns Object containing the date string and label
   */
  getPositionDateInfo(position: any, projectStaffListStatus: string): { date: Date, label: string } {
    const defaultDate = position.createdAt ? new Date(position.createdAt) : new Date();

    // Handle finished status positions
    if (this.isFinishedStatus(position.status)) {
      return this.getFinishedPositionInfo(position);
    }

    // Handle active positions
    return this.getActivePositionInfo(position, projectStaffListStatus, defaultDate);
  }

  private isFinishedStatus(status: string): boolean {
    return ['QUIT', 'FIRED', 'COMPLETED'].includes(status);
  }

  private getFinishedPositionInfo(position: any): { date: Date, label: string } {
    const date = new Date(position.finishedAt);
    const label = this.getFinishedStatusLabel(position);
    return { date, label };
  }

  private getFinishedStatusLabel(position: any): string {
    if (position.status === 'QUIT') {
      return 'Quit';
    }
    
    if (position.status === 'COMPLETED') {
      return 'Ended';
    }
    
    if (position.status === 'FIRED') {
      return this.getFiredStatusLabel(position);
    }
    
    return '';
  }

  private getFiredStatusLabel(position: any): string {
    if (position.presumptive && position.presumptive.status === 'DENIED') {
      return 'Denied';
    }
    return 'Fired';
  }

  private getActivePositionInfo(position: any, projectStaffListStatus: string, defaultDate: Date): { date: Date, label: string } {
    if (projectStaffListStatus === 'ARCHIVE') {
      return { date: new Date(position.finishedAt), label: 'Ended' };
    }
    
    if (projectStaffListStatus !== 'ARCHIVE' && position.status === 'OCCUPIED') {
      return { date: new Date(position.filledAt), label: 'Accepted' };
    }
    
    if (position.isPresumptivelyPending) {
      return this.getPresumptivePositionInfo(position, defaultDate);
    }
    
    return { date: defaultDate, label: '' };
  }

  private getPresumptivePositionInfo(position: any, defaultDate: Date): { date: Date, label: string } {
    const date = defaultDate;
    const label = position.status === this.presumtpivelyQuit ? 'Ended' : 'Pending';
    return { date, label };
  }
  
  getEndOfRoleTooltip(position: any): string {
    if (position.endedAcknowledgement) {
      if (position.endedAcknowledgeAt) {
        const readDate = new Date(position.endedAcknowledgeAt);
        return `End of role message: Read at ${readDate.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit', 
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        })}`;
      }
      return 'End of role message: READ';
    }
    return 'End of role message: NOT READ';
  }

  // Get active positions (not fired, quit, or completed)
  getActivePositions(positionsList: any[]): any[] {
    return positionsList.filter(position => { 
      return  ['OCCUPIED'].includes(position.status) &&
      (!position.presumptive || !['ASSIGNED','DENIED'].includes(position.presumptive.status));
    
    });
  }

  // Get previously assigned positions (fired, quit, completed)
  getPreviouslyAssignedPositions(positionsList: any[]): any[] {
    const positions = positionsList.filter(position => 
      ['FIRED', 'QUIT', 'COMPLETED', this.presumtpivelyQuit].includes(position.status) && !(position.presumptive && position.presumptive.status === 'DENIED')
    ).sort((current: any, next: any) => new Date(next.createdAt).getTime() - new Date(current.createdAt).getTime() );

    const uniqueMap = new Map();
    for (const pos of positions) {
      if (!uniqueMap.has(pos.reviewer._id)) {
        uniqueMap.set(pos.reviewer._id, pos);
      }
    }
    const uniqueLatestPositions = Array.from(uniqueMap.values());
    // console.log('uniqueLatestPositions', uniqueLatestPositions);
    return uniqueLatestPositions;
  }

  // Get positions that are pending approval
  getPendingApprovalPositions(positionsList: any[]): any[] {
    return positionsList.filter(position => (position.presumptive && position.presumptive.status === 'ASSIGNED' && position.status === 'OCCUPIED'));
  }

  getDeniedPositions(positionsList: any[]): any[] {
    return positionsList.filter(position => 
      position.presumptive && 
      position.presumptive.status === 'DENIED'
    );
  }
}
